/* Northsheep — the ⓘ after an advertised 15 % (snippets/ns-offer-info.liquid). One popover for the whole page
   (#NsOfferInfo, layout/theme.liquid), placed under the icon that opened it, or above it when there is no room below.

   How long it stays (owner, 30 Sep 2026: first "disappears too quick to read it fully", then "on hoover stays open and
   on mobile tab stays open scroll a bit and it closes or if its too long open"):
   - A MOUSE resting on the ⓘ opens it; it stays while the mouse is on the icon or the popover, and goes 0.8 s after
     the mouse has left both.
   - A TAP (or a click, which also pins a hover) opens it for reading: it goes once the page has been scrolled a bit
     (the icon has moved more than MOVE px, so a wobbling finger or a row nudging itself does not count), after LIFE ms,
     on a tap elsewhere, on a second tap on the icon, or on Escape. A mouse resting on the popover holds it open.
   While it is open it follows its icon: the popover is fixed, and the icon may sit in the scrolling basket drawer.

   Inside a link (promo tiles, the menu promo) the icon is a span, and the click is stopped here in the capture phase,
   so the tile does not follow its link.

   Registered once, on document: the basket and a colour swap redraw their icons without losing this. */
(function () {
  if (window.__nsOfferInfo) return;
  window.__nsOfferInfo = true;

  var MOVE = 40;
  var LIFE = 10000;
  var cur = null;
  var pinned = false;
  var leaveTimer = 0;
  var lifeTimer = 0;
  var start = null;

  function pop() {
    return document.getElementById('NsOfferInfo');
  }

  function iconOf(e) {
    return e.target && e.target.closest ? e.target.closest('[data-ns-oi]') : null;
  }

  function inPop(node) {
    return !!(node && node.closest && node.closest('#NsOfferInfo'));
  }

  function place(t) {
    var p = pop();
    if (!p) return;
    p.hidden = false;
    var r = t.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var vh = window.innerHeight;
    var w = p.offsetWidth;
    var h = p.offsetHeight;
    var x = Math.round(r.left + r.width / 2 - w / 2);
    x = Math.max(16, Math.min(x, vw - w - 16));
    var y = Math.round(r.bottom + 8);
    if (y + h > vh - 8 && r.top - 8 - h > 8) y = Math.round(r.top - 8 - h);
    p.style.left = x + 'px';
    p.style.top = y + 'px';
  }

  function open(t, pin) {
    clearTimeout(leaveTimer);
    clearTimeout(lifeTimer);
    if (cur && cur !== t) cur.setAttribute('aria-expanded', 'false');
    cur = t;
    pinned = !!pin;
    t.setAttribute('aria-expanded', 'true');
    var r = t.getBoundingClientRect();
    start = { x: r.left, y: r.top };
    place(t);
    if (pinned) lifeTimer = setTimeout(close, LIFE);
  }

  function close() {
    clearTimeout(leaveTimer);
    clearTimeout(lifeTimer);
    if (cur) cur.setAttribute('aria-expanded', 'false');
    cur = null;
    pinned = false;
    start = null;
    var p = pop();
    if (p) p.hidden = true;
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = iconOf(e);
      if (t) {
        e.preventDefault();
        e.stopPropagation();
        /* Opened by resting the mouse on it: the click pins it rather than closing it. */
        if (cur === t && pinned) close();
        else open(t, true);
        return;
      }
      if (cur && !inPop(e.target)) close();
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key === 'Escape' && cur) {
        var back = cur;
        close();
        back.focus();
        return;
      }
      /* A span inside a link: Enter and Space open it, and the link stays where it is. */
      var t = iconOf(e);
      if (t && t.tagName !== 'BUTTON' && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        e.stopPropagation();
        if (cur === t) close();
        else open(t, true);
      }
    },
    true
  );

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var t = iconOf(e);
    if (t) {
      if (cur !== t) open(t, false);
      clearTimeout(leaveTimer);
      return;
    }
    if (cur && inPop(e.target)) {
      clearTimeout(leaveTimer);
      /* Reading it with the mouse on it: a tap-opened popover does not time out under the pointer. */
      if (pinned) clearTimeout(lifeTimer);
    }
  });

  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse' || !cur) return;
    var from = iconOf(e) || (inPop(e.target) ? cur : null);
    if (from !== cur) return;
    var to = e.relatedTarget;
    if (to && (cur.contains(to) || inPop(to))) return;
    if (pinned) {
      clearTimeout(lifeTimer);
      lifeTimer = setTimeout(close, 4000);
    } else {
      leaveTimer = setTimeout(close, 800);
    }
  });

  /* Follow the icon; let go once the page has really been scrolled, or the icon is no longer drawn. */
  function follow() {
    if (!cur) return;
    var r = cur.getBoundingClientRect();
    var gone = !cur.isConnected || (r.width === 0 && r.height === 0);
    var moved = start ? Math.max(Math.abs(r.top - start.y), Math.abs(r.left - start.x)) : 0;
    if (gone || moved > MOVE) close();
    else place(cur);
  }
  document.addEventListener('scroll', follow, { capture: true, passive: true });
  window.addEventListener('resize', follow);
})();
